import { render, staticRenderFns } from "./MusicForm.vue?vue&type=template&id=5be0ebcb&scoped=true"
import script from "./MusicForm.vue?vue&type=script&setup=true&lang=js"
export * from "./MusicForm.vue?vue&type=script&setup=true&lang=js"
import style0 from "./MusicForm.vue?vue&type=style&index=0&id=5be0ebcb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be0ebcb",
  null
  
)

export default component.exports